import React from 'react';
import { SetupAreaVersionContext, useSetupAreaVersionContext } from './SetupAreaVersionContext';
import { Outlet } from 'react-router-dom';
import { TeamPermission } from 'nekst-api';
import { AccessChecker } from 'authorization-scope';
import { StateContext } from './StateContext';
import { PopupContext } from 'ui-builder';

function StateContextComponent(props: { children: React.ReactNode }) {

  const setupAreaVersion = useSetupAreaVersionContext();
  return (
    <StateContext state={setupAreaVersion?.setupArea.market?.state}>
      {props.children}
    </StateContext>
  );
}

export default function SetupAreaVersionWrapper() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_PORTAL}>
      <SetupAreaVersionContext>
        <StateContextComponent>
          <PopupContext>
            <Outlet />
          </PopupContext>
        </StateContextComponent>
      </SetupAreaVersionContext>
    </AccessChecker>
  );
}
